import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as records from '../records'

import type { TypeParams } from './types'

@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.everything<TypeParams>(
    (context, request) => {
      if (!context) {
        return rxjs.of([])
      }

      const spaceFilter = request?.filter?.additionalFilters?.spaceFilter
      const orgFilter = request?.filter?.additionalFilters?.orgFilter
      const responsiblePersonFilter =
        request?.filter?.additionalFilters?.responsiblePersonFilter
      const clusterFilter = request?.filter?.additionalFilters?.clusterFilter

      const filter = records.gql.inputs.filter.TRANSFORMER.getGqlFrom({
        includeInaccessible: true,
        roomTypeCategories: [ents.extra.space.RoomType.Category.Lab],
        ...(spaceFilter && { spaceFilter }),
        ...(orgFilter && { orgFilter }),
        ...(responsiblePersonFilter && { responsiblePersonFilter }),
        ...(clusterFilter && { clusterFilter }),
      })

      return records.gql.queries.spaceRecords.executor({
        ...context,
        filter,
        sort: request?.sort && {
          by: request.sort.by,
          descending: request.sort.descending,
        },
      })
    },
  )
}
